import ProjectPage from './ProjectPage';
import ProjectList from './ProjectList';
import EditProjectPage, { NewProjectPage } from './ProjectForm';

export default NewProjectPage;
export { ProjectPage, ProjectList, EditProjectPage };
